import Button from "@/common/components/Button";
import { bulkActionsEntryStatus } from "@/common/constants/bulkActions/entryStatus.constant";
import { BulkActionEntryData } from "@/common/types/bulkActions/entry.type";
import { getDateDiffFormatted } from "@/common/utils/date";
import { ArrowBigRightIcon } from "lucide-react";

export class BulkActionsMineEntriesTransformer {
  static tableTransformer(setSelectedEntry: React.Dispatch<React.SetStateAction<string | undefined>>) {
    return (entries: BulkActionEntryData[]) => {
      return entries.map((entry) => {
        return {
          status: bulkActionsEntryStatus[entry.status as keyof typeof bulkActionsEntryStatus] || entry.status,
          created_at: `há ${getDateDiffFormatted(new Date(), new Date(entry.created_at))}`,
          actions: (
            <Button variant="link-white" onClick={() => setSelectedEntry(entry.id)}>
              <ArrowBigRightIcon strokeWidth={1.5} />
            </Button>
          )
        };
      });
    };
  }
}
